import { combineReducers, createReducer } from 'utils/redux'

import * as actions from './actions'

const results = createReducer(
  {},
  {
    [actions.fetchConversationsDataSuccess.toString()]: ({
      draft,
      action: {
        payload: { queryConfig, response },
      },
    }) => {
      draft[JSON.stringify(queryConfig)] = response
    },
    [actions.fetchAvailabilityDataSuccess.toString()]: ({
      draft,
      action: {
        payload: { queryConfig, response },
      },
    }) => {
      draft.userAvailabilityCSVData = response
      draft[JSON.stringify(queryConfig)] = response
    },
  }
)

const createQueryState = () => ({
  isPending: false,
  isFinished: true,
  lastUpdated: 0,
})

const handleQueryComplete = ({
  draft,
  action: {
    payload: { queryConfig },
  },
}) => {
  const key = JSON.stringify(queryConfig)
  draft[key] = {
    ...draft[key],
    isFinished: true,
    isPending: false,
    lastUpdated: Date.now(),
  }
}

const handleExportPending = ({ draft, action: { payload } }) => {
  draft[JSON.stringify(payload)] = createQueryState()
  draft[`${JSON.stringify(payload.queryConfig)}-export`] = {
    isPending: true,
    isFinished: false,
  }
}

const handleExportComplete = ({ draft, action: { payload } }) => {
  const exportDraft = draft[`${JSON.stringify(payload.queryConfig)}-export`]
  exportDraft.isFinished = true
  exportDraft.isPending = false
  exportDraft.lastUpdated = Date.now()
}

const queries = createReducer(
  {},
  {
    [actions.fetchConversationsData.toString()]: ({
      draft,
      action: {
        payload: { queryConfig },
      },
    }) => {
      draft[JSON.stringify(queryConfig)] = createQueryState()
    },

    [actions.fetchAvailabilityData.toString()]: ({
      draft,
      action: {
        payload: { queryConfig },
      },
    }) => {
      draft[JSON.stringify(queryConfig)] = createQueryState()
    },

    [actions.fetchConversationsDataPending.toString()]: ({
      draft,
      action: { payload },
    }) => {
      draft[JSON.stringify(payload)].isFinished = false
      draft[JSON.stringify(payload)].isPending = true
    },

    [actions.fetchAvailabilityDataPending.toString()]: ({
      draft,
      action: { payload },
    }) => {
      draft[JSON.stringify(payload)].isFinished = false
      draft[JSON.stringify(payload)].isPending = true
    },

    [actions.fetchConversationsDataSuccess.toString()]: handleQueryComplete,
    [actions.fetchConversationsDataFailed.toString()]: handleQueryComplete,
    [actions.fetchAvailabilityDataSuccess.toString()]: handleQueryComplete,
    [actions.fetchAvailabilityDataFailed.toString()]: handleQueryComplete,

    [actions.exportConversationData.toString()]: handleExportPending,
    [actions.exportAllConversationData.toString()]: handleExportPending,

    [actions.exportConversationDataSuccess.toString()]: handleExportComplete,
    [actions.exportConversationDataFailed.toString()]: handleExportComplete,
  }
)

export default combineReducers({
  queries,
  results,
})
